var _defs, _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetStartedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32.001,
    viewBox: "0 0 32 32.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .getStartedA,\n            .getStartedB {\n                fill: #2196c9;\n            }\n\n            .getStartedA {\n                opacity: 0;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "getStartedA",
    width: 32,
    height: 32,
    transform: "translate(0 0.001)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.908)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "getStartedB",
    d: "M34.637,25.445a.8.8,0,0,0-1,.521.762.762,0,0,0,.481,1,11.546,11.546,0,1,1-7.537,0,.762.762,0,0,0,.481-1,.8.8,0,0,0-1-.521,13.149,13.149,0,1,0,8.579,0Z",
    transform: "translate(-17.197 -19.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "getStartedB",
    d: "M49.6,25.432V11.6a.8.8,0,0,0-1.6,0V25.432a.8.8,0,1,0,1.6,0Z",
    transform: "translate(-35.651 -10.8)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStartedIcon);
export default __webpack_public_path__ + "static/media/get-started-icon.ee01f0c7.svg";
export { ForwardRef as ReactComponent };